import { render } from "./EditShippingModal.vue?vue&type=template&id=0ff42304"
import script from "./EditShippingModal.vue?vue&type=script&lang=js"
export * from "./EditShippingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__